<template>
  <div>
    <h4
      v-bind="attributesBinding"
      :class="mainGrammar == 'Edit' ? 'text-center' : null"
    >
      <span>
        {{ currentField.value.ja ? currentField.value.ja : currentField.text }}
      </span>
    </h4>
    <p
      class="ma-0 text-caption pre-wrap"
      v-if="mainGrammar == 'Preview' && isLanguage !== 'ja'"
    >
      {{ captionText }}
    </p>
  </div>
</template>


<script>
export default {
  name: "Label",
  store: ["main", "mainGrammar", "isLanguage"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.id) {
        attr.id = `label-${this.currentField.id}`;
      }
      if (this.currentField.color) {
        attr.style = { color: this.currentField.color };
      }
      return attr;
    },
    captionText() {
      if (!this.currentField.value[this.isLanguage]) {
        return "";
      }
      return this.currentField.value[this.isLanguage];
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
p {
  word-wrap: break-word !important;
  white-space: pre-line;
  line-height: 1 !important;
}
h4 {
  user-select: none;
  word-wrap: break-word;
  white-space: pre-line;
}
</style>
